import CheckSignOff from '../../components/CheckSignOff';
import { useFoodTemperature } from '../context/FoodTemperatureContext';
import React, { useEffect, useState } from 'react';
import { IoChevronDown, IoTimeOutline } from 'react-icons/io5';

export default function ManagerSignOff() {
  const [noteText, setNoteText] = useState('');
  const maxLength = 250;
  const { checklist, selectedDate, submission, selectedUser, staff, selectUser } = useFoodTemperature();
  useEffect(() => { setNoteText(submission?.openingNotes || ''); }, [selectedDate, submission?.openingNotes]);

  return (
    <div className="w-full  p-6 bg-white border border-gray-100 rounded-2xl shadow-sm">
      {/* Headings */}
      <div className="mb-5">
        <h2 className="text-lg font-bold text-gray-900">Manager Sign-Off</h2>
        <p className="mt-1 text-xs font-medium text-gray-400">
          Confirm all temperature checks have been completed and any necessary actions have been taken.
        </p>
      </div>

      {/* Main Layout Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 items-start">
        
        {/* Input Controls Block */}
        <div className="lg:col-span-9 grid grid-cols-1 md:grid-cols-3 gap-4">
          
          {/* Completed By Dropdown */}
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-bold text-gray-500">Completed by</label>
            <div className="relative">
              <select value={selectedUser?.id || ""} onChange={event => { const user = staff.find(user => String(user.id) === event.target.value); if (user) selectUser(user); }} className="w-full pl-3 pr-10 py-2.5 text-sm font-medium text-gray-400 bg-white border border-gray-200 rounded-xl appearance-none focus:outline-none focus:border-indigo-500 transition-all cursor-pointer">
                <option value="">Select staff member</option>
                {staff.map(user => <option key={user.id} value={user.id}>{user.fullName}</option>)}
              </select>
              <IoChevronDown className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-base pointer-events-none" />
            </div>
          </div>

          {/* Time Completed Input */}
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-bold text-gray-500">Time completed</label>
            <div className="relative">
              <input 
                type="text"
                readOnly
                value={submission?.submissionDate ? new Date(submission.submissionDate).toLocaleString() : ""} 
                placeholder="--:--"
                className="w-full pl-3 pr-10 py-2.5 text-sm font-medium text-gray-400 bg-white border border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 transition-all"
              />
              <IoTimeOutline className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg pointer-events-none" />
            </div>
          </div>

          {/* Notes Input Area */}
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-bold text-gray-500">
              Notes <span className="text-gray-400 font-normal">(optional)</span>
            </label>
            <div className="relative flex flex-col">
              <textarea 
                rows="2"
                placeholder="Add any notes or issues..."
                maxLength={maxLength}
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
                className="w-full px-3 py-2 text-sm font-medium text-gray-800 bg-white border border-gray-200 rounded-xl placeholder-gray-300 focus:outline-none focus:border-indigo-500 transition-all resize-none min-h-[76px]"
              />
              {/* Character Limit Badge Counter */}
              <span className="absolute bottom-2 right-3 text-[10px] font-semibold text-gray-400 tracking-wider">
                {noteText.length} / {maxLength}
              </span>
            </div>
          </div>

        </div>

        {/* Action Button Section */}
        <div className="lg:col-span-3 flex flex-col gap-2 w-full lg:mt-5">
<CheckSignOff checklistId={checklist?.id} creationDate={selectedDate}
            fields={{ openingNotes: noteText, completedById: selectedUser?.id }} />
          
          <p className="text-[11px] font-medium text-gray-400 text-center lg:text-left pl-1">
            Approve the check before submitting.
          </p>
        </div>

      </div>
    </div>
  );
}

